import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { generateCorrelationId, setCorrelationId } from '@/lib/correlationId';
import axios from 'axios';

export function useDatadogCorrelation() {
  useEffect(() => {
    const correlationId = generateCorrelationId();
    setCorrelationId(correlationId);

    const headers = axios.defaults.headers.common;
    headers['X-Correlation-ID'] = correlationId;
    headers['X-Request-ID'] = correlationId;

    datadogRum.setGlobalContextProperty('correlationId', correlationId);
  }, []);
}
